<template>
  <transition name="executor-float-slide">
    <div
      v-if="visible"
      class="executor-float"
      @click="$emit('expand')"
    >
      <div class="executor-float-header">
        <span class="executor-float-title">{{ title }}</span>
        <span class="executor-float-pct">{{ pct }}%</span>
      </div>
      <b-progress
        :value="pct"
        :max="100"
        :animated="running"
        :variant="variant"
        class="executor-float-bar"
      />
      <div class="executor-float-footer">
        <span class="executor-float-hint">Clic para ver detalle</span>
        <span
          class="executor-float-cancel"
          @click.stop="$emit('cancel')"
        >Cancelar</span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ExecutorProgressFloat',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: 'Procesando...' },
    pct: { type: Number, default: 0 },
    running: { type: Boolean, default: true },
    variant: { type: String, default: 'primary' }
  }
}
</script>

<style scoped>
.executor-float {
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  z-index: 2000;
  width: 260px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14);
  padding: 0.875rem 1rem;
  cursor: pointer;
  border-left: 3px solid #4299e1;
  transition: box-shadow 0.2s ease;
}

.executor-float:hover {
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18);
}

.executor-float-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 0.5rem;
}

.executor-float-title {
  font-size: 0.8rem;
  font-weight: 600;
  color: #2d3748;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}

.executor-float-pct {
  font-size: 0.75rem;
  font-weight: 600;
  color: #4299e1;
  font-variant-numeric: tabular-nums;
  flex-shrink: 0;
}

.executor-float-bar {
  height: 5px;
  border-radius: 3px;
  margin-bottom: 0.375rem;
}

.executor-float-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.executor-float-hint {
  font-size: 0.7rem;
  color: #a0aec0;
}

.executor-float-cancel {
  font-size: 0.7rem;
  color: #e53e3e;
  cursor: pointer;
  font-weight: 500;
}

.executor-float-cancel:hover {
  text-decoration: underline;
}

/* Slide-up transition */
.executor-float-slide-enter-active,
.executor-float-slide-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.executor-float-slide-enter,
.executor-float-slide-leave-to {
  opacity: 0;
  transform: translateY(12px);
}
</style>



// WEBPACK FOOTER //
// src/components/ExecutorProgressFloat.vue